import { render, staticRenderFns } from "./pi-site-change-record.vue?vue&type=template&id=6a1835f6&"
import script from "./pi-site-change-record.vue?vue&type=script&lang=ts&"
export * from "./pi-site-change-record.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports